<template>
    <div>
        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    background-color="secondary"
                    closed
                    no-margin-top
                    title="Arcada superior"
                    type="box"
                >
                    <BoxProcedimento :data="{additionals: data.additionals, model: getArcadas().superior}" />

                    <rkm-row class="mt-2">
                        <rkm-col cols="12">
                            <rkm-form-textarea
                                :validations="validations.observacao"
                                label="Observações"
                                rows="6"
                                v-model="getArcadas().superior.observacao"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-button
                                :disabled="getArcadas().superior.procedimentos.length === 0"
                                @click="includeProcedimentosArcadaInferior"
                                block
                                color="primary"
                            >
                                Replicar procedimentos para a arcada inferior
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-1">
            <rkm-col cols="12">
                <rkm-area
                    background-color="secondary"
                    closed
                    title="Arcada inferior"
                    type="box"
                >
                    <BoxProcedimento :data="{additionals: data.additionals, model: getArcadas().inferior}" />

                    <rkm-row class="mt-2">
                        <rkm-col cols="12">
                            <rkm-form-textarea
                                :validations="validations.observacao"
                                label="Observações"
                                rows="6"
                                v-model="getArcadas().inferior.observacao"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row class="mt-2">
                        <rkm-col>
                            <rkm-button
                                :disabled="getArcadas().inferior.procedimentos.length === 0"
                                @click="includeProcedimentosArcadaSuperior"
                                block
                                color="primary"
                            >
                                Replicar procedimentos para a arcada superior
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Components.
import BoxProcedimento from '@/components/ambulatorio/atendimento/components/soap/components/plano/components/odontograma/components/procedimento/Index'

// Mixins.
import {object} from '@/mixins'

export default {
    components: {BoxProcedimento},
    computed: {
        validations() {
            return {
                observacao: {max: 5000},
            }
        },
    },
    methods: {
        includeProcedimentosArcadaInferior() {
            const onConfirm = async () => {
                this.getArcadas().superior.procedimentos.forEach(procedimento => {
                    const hasProcedimento = this.getArcadas().inferior.procedimentos.find(p => p.procedimento.id === procedimento.procedimento.id)

                    if (!hasProcedimento) {
                        this.getArcadas().inferior.procedimentos.push(this.clone(procedimento))
                    }
                })
            }

            this.showConfirmation('Deseja realmente replicar o(s) procedimento(s) para a arcada inferior?', onConfirm)

        },
        includeProcedimentosArcadaSuperior() {
            const onConfirm = async () => {
                this.getArcadas().inferior.procedimentos.forEach(procedimento => {
                    const hasProcedimento = this.getArcadas().superior.procedimentos.find(p => p.procedimento.id === procedimento.procedimento.id)

                    if (!hasProcedimento) {
                        this.getArcadas().superior.procedimentos.push(this.clone(procedimento))
                    }
                })
            }

            this.showConfirmation('Deseja realmente replicar o(s) procedimento(s) para a arcada superior?', onConfirm)
        },
        getArcadas() {
            return this.data.model.saudeBucal.odontograma.arcadas
        },
    },
    mixins: [object],
    props: {
        data: {type: Object, required: true},
    },
}
</script>